import { useState, useEffect } from 'react';
import { createHashTable } from '../helper/general';
const useHashTable = treeNodes => {
  const [hashTable, setHashTable] = useState(new Map());
  useEffect(() => {
    const hashTableData = createHashTable(treeNodes);
    setHashTable(hashTableData);
  }, [treeNodes]);
  return {
    hashTable
  };
};
export default useHashTable;